import { QueryOptions, useQuery } from "@tanstack/react-query";

import {
	GetLibraryAndResourceDto,
	GetLibraryResponseDto,
	OrderByEnum,
	restRepository,
} from "@onair/repositories";
import {
	GET_LIBRARY_AND_RESOURCE_BY_LIBRARY_ID,
	GET_LIBRARY_USAGE_IN_COURSES,
	GET_ROOT_LIBRARY,
	GET_ADMIN_ROOT_LIBRARY,
} from "../../keys";

export const useAdminGetRootLibraryQuery = (ownerId?: string) => {
	return useQuery({
		queryKey: [GET_ADMIN_ROOT_LIBRARY, ownerId],
		queryFn: async () => {
			try {
				const response = await restRepository.api.adminLibraryGetRoot(ownerId!);
				return response.data || null;
			} catch (error) {
				console.error("Admin root library error:", error);
				throw error;
			}
		},
		enabled: !!ownerId,
	});
};

export const useGetLibraryAndResourceByLibraryIdQuery = (
	id: string,
	options = {},
	query?: { order: OrderByEnum; orderField: string },
) => {
	return useQuery({
		...options,
		queryKey: [GET_LIBRARY_AND_RESOURCE_BY_LIBRARY_ID, id, query],
		queryFn: async () => {
			if (!id) return null;
			const response =
				await restRepository.api.libraryGetLibraryAndResourceByLibraryId(
					id,
					query,
				);
			return response.data as GetLibraryAndResourceDto;
		},
		staleTime: 0,
		enabled: !!id,
	});
};

export const useLibraryCheckUsageInCoursesQuery = (libraryId: string) => {
	return useQuery({
		queryKey: [GET_LIBRARY_USAGE_IN_COURSES, libraryId],
		queryFn: async () => {
			if (libraryId) {
				const response =
					await restRepository.api.libraryCheckUsageInCourses(libraryId);
				return response.data;
			}
		},
		enabled: !!libraryId,
	});
};

export const useGetRootLibraryQuery = (options: { enabled?: boolean }) => {
	const { enabled = false } = options;
	return useQuery({
		queryKey: [GET_ROOT_LIBRARY],
		queryFn: async () => {
			const response = await restRepository.api.libraryGetRoot();
			return response.data as GetLibraryResponseDto;
		},
		enabled,
	});
};
